import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/services/api';

export const useProjectManager = () => {
  const { user } = useAuth();
  const [hasAccessToProjectCosts, setHasAccessToProjectCosts] = useState(false);
  const [isProjectManager, setIsProjectManager] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkProjectAccess = async () => {
      if (!user) {
        setHasAccessToProjectCosts(false);
        setIsProjectManager(false);
        setLoading(false);
        return;
      }

      // 管理员始终有访问权限
      if (user.role === 'admin') {
        setHasAccessToProjectCosts(true);
        setIsProjectManager(true); // admin也算作项目管理者
        setLoading(false);
        return;
      }

      try {
        // 检查用户是否有管理的项目
        const projects = await api.getCostAccessibleProjects();
        const hasProjects = projects.length > 0;
        setHasAccessToProjectCosts(hasProjects);
        setIsProjectManager(hasProjects); // 如果有管理的项目，就是项目管理者
      } catch (error) {
        console.error('检查项目访问权限失败:', error);
        setHasAccessToProjectCosts(false);
        setIsProjectManager(false);
      } finally {
        setLoading(false);
      }
    };

    checkProjectAccess();
  }, [user]);

  return { hasAccessToProjectCosts, isProjectManager, loading };
};